<template lang="pug">
  .iconChart
    .iconChart-chart
      .chart
        .item(v-for="(item, index) in items" :key="index")
          .image
            component(:is="item.icon" class="iconChart-chart-item-image-icon")
          .content
            h3(v-html="item.number + '%'" :class="fontColor")
            p(v-html="item.copy")
</template>

<script>
import IconBuySave from '@/assets/img/icons/buy-save.svg'
import IconBooks from '@/assets/img/icons/books.svg'
import IconCash from '@/assets/img/icons/cash.svg'
import IconClothing from '@/assets/img/icons/clothing.svg'
import IconGames from '@/assets/img/icons/games.svg'
import IconDecor from '@/assets/img/icons/decor.svg'
import IconDiscounts from '@/assets/img/icons/discounts.svg'
import IconElectronics from '@/assets/img/icons/electronics.svg'
import IconExchange from '@/assets/img/icons/exchange.svg'
import IconFood from '@/assets/img/icons/food.svg'
import IconGiftCards from '@/assets/img/icons/gift-cards.svg'
import IconGifts from '@/assets/img/icons/gifts.svg'
import IconJewelry from '@/assets/img/icons/jewelry.svg'
import IconPersonalCare from '@/assets/img/icons/personal-care.svg'
import IconLoyalty from '@/assets/img/icons/loyalty.svg'
import IconShipping from '@/assets/img/icons/shipping.svg'
import IconToys from '@/assets/img/icons/toys.svg'

export default {
  name: 'iconChart',
  props: {
    items: {
      type: Array,
      required: true,
    },
    fontColor: String
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  components: {
    IconBuySave,
    IconBooks,
    IconCash,
    IconClothing,
    IconGames,
    IconDecor,
    IconDiscounts,
    IconElectronics,
    IconExchange,
    IconFood,
    IconGiftCards,
    IconGifts,
    IconJewelry,
    IconPersonalCare,
    IconLoyalty,
    IconShipping,
    IconToys,
  },
}
</script>

<style scoped lang="scss">
.iconChart {
  max-width: 55%;
  margin: 0 auto;
  
  .header-container {
    text-align: center;
  }

  .chart {
    width: 100%;
  }

  .item {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    padding: 1.5rem 0;
  }

  .image {
    width: 33%;
    padding-right: 2rem;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    display: inline-block;
    vertical-align: middle;
  }

  .black {
    color: #000;
  }

  h3 {
    color: #000;
  }

  p {
    font-size: 1.75rem;
  }

  @media #{$mobile} {
    .item {
      padding: .8rem 0;
    }

    p {
      font-size: 1.7rem;
    }
  }
}
</style>
